import { concatStyleSets, IRawStyle, ITextFieldStyles } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, FontWeights, Sizes } from '../../themes/styles';

const statusCircleIcon = (theme: IH2OTheme): IRawStyle => ({
  color: theme.palette?.white,
  borderRadius: '50%',
  width: 14,
  height: 14,
  lineHeight: 13,
  fontWeight: FontWeights.bold,
  fontSize: '15px',
  bottom: 8,
});

export const textFieldStylesDefault = (theme: IH2OTheme): Partial<ITextFieldStyles> => ({
  root: {
    '&.is-disabled': {
      '.ms-TextField-fieldGroup': {
        pointerEvents: 'none',
        borderColor: theme.semanticColors?.inputDisabledBorder,
        overflow: 'hidden',
      },
      '.ms-TextField-field': {
        '::placeholder': {
          color: theme.semanticColors?.textDisabled,
        },
      },
    },
    '&.has-error': {
      '.ms-TextField-fieldGroup': {
        borderColor: theme.semanticColors?.inputErrorBorder,
        i: {
          ...statusCircleIcon(theme),
          backgroundColor: theme.palette?.red500,
        },
      },
    },
    '&.is-success': {
      '.ms-TextField-fieldGroup': {
        borderColor: theme.semanticColors?.inputSuccessBorder,
        i: {
          ...statusCircleIcon(theme),
          backgroundColor: theme.palette?.green500,
        },
      },
      '.ms-TextField-description': {
        color: theme.semanticColors?.inputSuccessMessageText,
      },
    },
    '.ms-Label': {
      color: theme.semanticColors?.inputLabel,
    },
  },
  fieldGroup: {
    height: Sizes.height,
    border: `1px solid ${theme.semanticColors?.inputBorder}`,
    borderRadius: Sizes.borderRadius,
    ':hover': {
      borderColor: theme.semanticColors?.inputActiveBorder,
    },
    ':focus': {
      borderColor: theme.semanticColors?.inputActiveBorder,
    },
    '::after': {
      display: 'none',
    },
    '.is-active': { borderColor: theme.semanticColors?.inputActiveBorder },
  },
  field: {
    color: theme.semanticColors?.inputText,
    paddingLeft: Sizes.padding,
    paddingRight: Sizes.padding,
    lineHeight: Sizes.height - 2,
    '::placeholder': {
      color: theme.semanticColors?.inputPlaceholder,
    },
  },
  errorMessage: {
    color: theme.semanticColors?.inputErrorMessageText,
    fontSize: FontSizes.inputDescription,
    fontWeight: FontWeights.inputDescription,
  },
  description: {
    fontSize: FontSizes.inputDescription,
    fontWeight: FontWeights.inputDescription,
  },
});

export const textFieldStylesEditor = (theme: IH2OTheme): Partial<ITextFieldStyles> =>
  concatStyleSets(textFieldStylesDefault(theme), {
    root: { height: '100%' },
    fieldGroup: { height: '100%' },
    wrapper: { height: '100%' },
  }) as Partial<ITextFieldStyles>;

export const textFieldStylesTextList: Partial<ITextFieldStyles> = {
  root: { height: '27px', marginRight: '4px', width: '170px' },
  fieldGroup: { height: '27px' },
  wrapper: { height: '27px' },
};
